import Vue from "vue";
import { Plugin } from "vue-fragment";

export default Vue.use(Plugin);
